var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 0H8C3.58172 0 0 3.58172 0 8V122C0 126.418 3.58172 130 8 130H122C126.418 130 130 126.418 130 122V8C130 3.58172 126.418 0 122 0Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 104C75.3434 104 85.2632 99.8911 92.5772 92.5772C99.8911 85.2632 104 75.3434 104 65C104 54.6566 99.8911 44.7368 92.5772 37.4228C85.2632 30.1089 75.3434 26 65 26C54.6566 26 44.7368 30.1089 37.4228 37.4228C30.1089 44.7368 26 54.6566 26 65C26 75.3434 30.1089 85.2632 37.4228 92.5772C44.7368 99.8911 54.6566 104 65 104ZM84.5 65L52.8125 84.5V45.5L84.5 65Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white",
    transform: "translate(26 26)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackflow);
export default __webpack_public_path__ + "static/media/feedbackflow.da130331022623650eb7bbc2745fd02a.svg";
export { ForwardRef as ReactComponent };